import { AssistantMessage } from '@/components/virtual-assistant/virtual-assistant-timeline';

export const requestMapper = (response) => {
	const messagesListFromHistory: AssistantMessage[] = [];

	const hasOnlyInit = response.history.length === 1 && response.history[0].prompt === '__INIT__';

	(hasOnlyInit ? response.history : response.history.filter((message) => message.prompt !== '__INIT__')).map((message, index) => {
		if (message.prompt && message.prompt !== '__INIT__') {
			const botId = `user-${Date.now()}${index}`;
			messagesListFromHistory.push({
				id: botId,
				role: 'user',
				status: 'done',
				text: message.prompt,
			});
		}
		if (message.message) {
			const botId = `bot-${Date.now()}${index}`;
			messagesListFromHistory.push({
				id: botId,
				role: 'assistant',
				status: 'done',
				text: message.message,
				suggestions: message.suggestions,
				products: message.baseProducts,
			});
		}
	});
	response.history = messagesListFromHistory;
	return response;
};
